const notifications = {
  title: 'Notificaciones',
  empty: 'Sin notificaciones',
  emptyDescription: '¡Estás al día!',
  errorTitle: 'Error al cargar las notificaciones',
  errorDescription: 'Por favor, intente de nuevo más tarde',
  markAllAsRead: 'Marcar todo como leído',
  viewAll: 'Ver todo',
};

export const es = {
  notifications,
};
